import { render, staticRenderFns } from "./molecule.modal.shareYourDesignform.vue?vue&type=template&id=10e0ecdc"
import script from "./molecule.modal.shareYourDesignform.vue?vue&type=script&lang=ts"
export * from "./molecule.modal.shareYourDesignform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports